import React, { useRef, useState, useEffect } from 'react'
import styles from './AliPay.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { Button, message, Modal, QRCode, Result } from 'antd'
import alipayIcon from './alipayIcon.svg'
import qrcodeImg from './QR.svg'
import { checkPayResultRequest } from './api'

let checkPayInterval = null
export default function AliPay(props) {
  const dispatch = useDispatch()
  const [confirmInfo, setConfirmInfo] = useState({})
  const [messageApi, contextHolder] = message.useMessage()
  const [payResult, setPayResult] = useState({
    result: 0,
    msg: '',
    subTitle: '',
  })
  useEffect(() => {
    checkPayInterval = setInterval(() => {
      checkPayResult(props.outTradeNo)
    }, 5000)
    return () => {
      // 组件卸载前移除事件监听
      clearInterval(checkPayInterval)
    }
  }, [])

  function checkPayResult(dingdanCode) {
    checkPayResultRequest(dingdanCode, (res) => {
      if (res.ret==1) {
        setPayResult({
          result: 1,
          msg: "支付成功",
          subTitle: '    缴费时间' + res.data.jiaofei_time+ '    ',
        })
        clearInterval(checkPayInterval)
        // setTimeout(() => {
        //   props.changePayWay(0)
        // }, 3000);
      } else {
        messageApi.error(res.msg)
      }

      if (payResult.result != 0) {
        clearInterval(checkPayInterval)
        return
      }
    })
  }
  function checkPayResult1(dingdanCode) {
    checkPayResultRequest(dingdanCode, (res) => {
      if (res.ret==1) {
        setPayResult({
          result: 1,
          msg: "支付成功",
          subTitle: '    缴费时间' + res.data.jiaofei_time+ '    ',
        })
        clearInterval(checkPayInterval)
        setTimeout(() => {
          props.changePayWay(1)
        }, 3000);
      } else {
        message.error("缴费失败")
      }

      if (payResult.result != 0) {
        clearInterval(checkPayInterval)
        return
      }
    })
  }
  return (
    <div className={styles.wechatPay}>
      <div className={styles.title1Div}>
        <img src={alipayIcon} className={styles.wechatIcon} />
        微信支付
      </div>
      <div className={styles.title2Div}>请在新标签页扫码充值积分</div>
      <div className={styles.title3Div}>{props.amount}元</div>
      <img src={qrcodeImg} className={styles.qrcodeImg} />
      {/* <QRCode
        errorLevel="H"
        value="https://ant.design/"
        style={{ marginTop:20}}
        size={180}
        // icon="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
      /> */}
      {/* <div
      style={{fontSize:12,color:'#E6521F',marginTop:30}}
      >请在15分钟内完成支付，14:34:25</div> */}
      <Modal
        title="支付宝支付"
        open={payResult.result == 0}
        // onCancel={() => setVisible(false)}
        onCancel={() => {
          props.changePayWay(1)
        }}
        footer={null}
      >
        <div className={styles.alertContent}>
          您已打开支付宝支付页面，请在支付宝支付页面完成支付
          <Button type="primary" style={{marginTop:40}} onClick={() => {
            checkPayResult1(props.outTradeNo)
          }}>
            已完成支付
          </Button>
        </div>
        
      </Modal>


      {payResult.result != 0 ? (
        <Result
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
          }}
          status={payResult.result == 1 ? 'success' : 'error'}
          title={payResult.msg}
          // subTitle={
          //   payResult.result == 1
          //     ? `   交费时间：${new Date().toLocaleString()}   `
          //     : '        '
          // }
          subTitle={payResult.subTitle}
          extra={[
            // <Button type="primary" key="console">
            //   确认
            // </Button>,
            payResult.result == 1 ? (
              <Button
                type="primary"
                key="buy"
                style={{ marginLeft: 40, marginRight: 40 }}
                onClick={() => {
                  // getWXQrUrl()
                  props.changePayWay(1)
                }}
              >
                确认
              </Button>
            ) : null,
          ]}
        />
      ) : null}
    </div>
  )
}
// export default PaymentInfoList;

